window.ezfy = window.ezfy || {};

ezfy = (function () {
  window.discounts = [
    {
      quantity: 2,
      percentage: 20,
      amount: `20%`,
      coupon: "DVJTI5KV1I85",
    },

    {
      quantity: 3,
      percentage: 30,
      amount: `30%`,
      coupon: "8OMNVUPW20ZH",
    },
  ];

  function _loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s;
      s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function _extractTextBetween(text, start, end) {
    if (!start || !end) {
      throw new Error(`Please add a "start" and "end" parameter`);
    }

    return text.split(start)[1].split(end)[0];
  }

  function _loadStyle(src) {
    return new Promise(function (resolve, reject) {
      let link = document.createElement("link");
      link.href = src;
      link.rel = "stylesheet";

      link.onload = () => resolve(link);
      link.onerror = () => reject(new Error(`Style load error for ${src}`));

      document.head.append(link);
    });
  }

  function _moveDOMElement(parent, child) {
    document.querySelector(parent).appendChild(document.querySelector(child));
  }

  function _isProductPage() {
    return /product/.test(window.location.href);
  }

  function _isCartPage() {
    return /cart/.test(window.location.href);
  }

  function isCollectionsPage() {
    return /\/collections\/.*(\/)?$/.test(window.location.pathname);
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function _waitForElement(selector, delay = 50, tries = 100) {
    const element = document.querySelector(selector);

    if (!window[`__${selector}`]) {
      window[`__${selector}`] = 0;
      window[`__${selector}__delay`] = delay;
      window[`__${selector}__tries`] = tries;
    }

    function _search() {
      return new Promise((resolve) => {
        window[`__${selector}`]++;
        setTimeout(resolve, window[`__${selector}__delay`]);
      });
    }

    if (element === null) {
      if (window[`__${selector}`] >= window[`__${selector}__tries`]) {
        window[`__${selector}`] = 0;
        return Promise.resolve(null);
      }

      return _search().then(() => _waitForElement(selector));
    } else {
      return Promise.resolve(element);
    }
  }

  function _addStyle(styleString) {
    const style = document.createElement("style");
    style.textContent = styleString;
    document.head.append(style);
  }

  function loadEcwidScript() {
    return new Promise(async (resolve, reject) => {
      try {

        if (window.hasOwnProperty(`Ecwid`) &&
           window.Ecwid.hasOwnProperty(`Cart`) &&
            window.Ecwid.Cart.hasOwnProperty(`gotoCheckout`)
           ){
                console.log(`[ECWID] already loaded!`)
          resolve()
          return
           }
        
        const url = `https://app.ecwid.com/script.js?61271341&data_platform=code&data_date=2024-10-15`;
        const $script = document.querySelector(`script[src*='app.ecwid']`);

        if ($script ) {
          window.Ecwid.init();
          resolve();
          return;
        }

        console.log(`[ECWID] loading for the first time.`)
        await _loadScript(url);
        window.Ecwid.init();
        resolve();
      } catch (err) {
        console.log(`Unable to load Ecwid. - loadEcwidScript()`);
        reject(err);
      }
    });
  }

  function getShopifyCart() {
    return new Promise((resolve, reject) => {
      fetch("/cart.js")
        .then((response) => {
          if (!response.ok) {
            reject("Failed to fetch cart");
          }
          return response.json();
        })
        .then((cart) => resolve(cart))
        .catch((error) => reject(error));
    });
  }

  async function awaitEcwid() {
    return new Promise(async (resolve, reject) => {
      while (!window.hasOwnProperty("Ecwid")) {
        console.log("waiting for Ecwid          ");
        await new Promise((resolve) => setTimeout(resolve, 10));
      }

      while (!Ecwid.hasOwnProperty("Cart")) {
        console.log("waiting for Ecwid Cart");
        await new Promise((resolve) => setTimeout(resolve, 10));
      }

      while (!Ecwid.Cart.hasOwnProperty("addProduct")) {
        console.log("waiting for 'addProduct'                      ");
        await new Promise((resolve) => setTimeout(resolve, 10));
      }

      resolve();
    });
  }

  const checkoutButton = {
    checkoutStartMessage: function () {
      const $buttons = document.querySelectorAll(`[name='checkout']`);
      for (const button of $buttons) {
        button.textContent = "Loading...";
        button.classList.add("CheckoutButton--is-loading");
      }
    },
    idle: function () {
      const $buttons = document.querySelectorAll(`[name='checkout']`);
      for (const button of $buttons) {
        button.textContent = "Checkout";
        button.classList.remove("CheckoutButton--is-loading");
      }
    },
    checkoutMiddleMessage: function () {
      const $buttons = document.querySelectorAll(`[name='checkout']`);
      for (const button of $buttons) {
        button.textContent = "Connecting to checkout...";
        button.classList.add("CheckoutButton--is-loading");
      }
    },
    checkoutCompletedMessage: function () {
      const $buttons = document.querySelectorAll(`[name='checkout']`);
      for (const button of $buttons) {
        button.textContent = "Adding product(s)...";
        button.classList.add("CheckoutButton--is-loading");

            setTimeout(() => {
      // button.textContent = "Almost there...";
    }, 2000);
      }
    },
  };

  function test(){
    fetch('https://xwh1tv-pp.myshopify.com/admin/api/2024-01/customers.json', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': 'c0937ef4d3fa47f5d2cb2eca77c85e3a',
    },
    body: JSON.stringify({
        customer: {
            email: 'customer@example.com',
            first_name: 'First',
            last_name: 'Last',
        },
    }),
})
.then(response => response.json())
.then(data => console.log(data))
.catch(error => console.error('Error:', error));
  }

  async function addShopifyProductsToEcwidCart() {
    return new Promise(async (resolve, reject) => {
      checkoutButton.checkoutStartMessage();

      const cart = await getShopifyCart();
      const ecwidProducts = await getEcwidProducts();
      const products = cart.items
        .map((each) => {
          return ecwidProducts.items.find(
            (product) => product.autogeneratedSlug === each.handle
          );
        })
        .filter((product) => product !== undefined);

      checkoutButton.checkoutMiddleMessage();
      let addedCount = 0;
      let totalProducts = products.length;

      await loadEcwidScript();
      await awaitEcwid();

      Ecwid.Cart.clear();
       await sleep(500);
      checkoutButton.checkoutCompletedMessage();
      await sleep(500);

      products.forEach((productData) => {
        Ecwid.Cart.addProduct({
          id: productData.id,
          quantity: 1,
          callback: function (success, product, cart) {
            if (!success) {
              console.error(`[ECWID CART] Failed to add product: `, success);
              reject("Failed to add product");
               checkoutButton.idle();
              // window.location.reload();
              return;
            }
            addedCount++;
            
            if (addedCount === totalProducts) {
              checkoutButton.idle();
 
              Ecwid.Cart.gotoCheckout();
              addDiscountCoupon(products)
              console.log(`[ECWID CART] All products added successfully`)
              resolve("All products added successfully");
            }

            checkoutButton.idle();
          },
        });
      });
    });
  }

  function getEcwidProducts() {
    return new Promise(async (resolve, reject) => {
      try {
        const lastFetch = localStorage.getItem("ecwidLastFetch");
        const storedProducts = localStorage.getItem("ecwidProducts");
        const currentTime = new Date().getTime();

        if (!lastFetch || currentTime - lastFetch > 2 * 60 * 60 * 1000) {
          console.log("Fetching Ecwid products...");
          const response = await fetch(
            "https://app.ecwid.com/api/v3/61271341/products?token=public_iNxZWDXrKMZrzGkdBWk3fvcfaJhBVgcm"
          );
          const ecwidProducts = await response.json();
          localStorage.setItem("ecwidProducts", JSON.stringify(ecwidProducts));
          localStorage.setItem("ecwidLastFetch", currentTime.toString());
          console.log(`Ecwid products fetched!`, ecwidProducts);
          resolve(ecwidProducts);
        } else {
          console.log(
            `Data is up to date. Ecwid products fetched at ${new Date(
              parseInt(lastFetch)
            ).toLocaleString()}`
          );
          resolve(JSON.parse(storedProducts));
        }
      } catch (err) {
        console.log("Error fetching Ecwid products:", err);
        reject(err);
      }
    });
  }

  /* Whenever clicking on the 'checkout' button, open ecwid's checkout */
  function openEcwidCheckoutOnShopifyCheckoutClick() {
    const $checkout = document.querySelectorAll(`[name='checkout']`);

    if (!$checkout) {
      return;
    }

    for (var each of $checkout) {
      each.addEventListener(`click`, async function (e) {
        e.preventDefault();

        await addShopifyProductsToEcwidCart();
      });
    }
  }

  function handleBackButton() {
    window.addEventListener("popstate", function (event) {
      redirectToCartIfEcwidCartIsOpen();
    });
  }

  function redirectToCartIfEcwidCartIsOpen() {
    if (window.location.href.includes("/~/cart")) {
      const newUrl = window.location.href.replace(`#!/~/cart`, "");
      window.history.pushState({}, "", newUrl);
    }
  }

  function oneQuantityPerProduct() {
    const cartForm = document.querySelectorAll('form[action="/cart/change"]');

    if (cartForm) {
      cartForm.forEach((form) => {
        form.addEventListener("submit", (e) => {
          const quantityField = form.querySelector('[name="quantity"]');
          if (quantityField && quantityField.value > 1) {
            e.preventDefault();
            alert("Only one quantity of each product is allowed.");
            quantityField.value = 1;
          }
        });
      });
    }
  }

  function redirectOldWebsiteShop() {
    const currentUrl = window.location.href;

    if (currentUrl.includes("/shop/")) {
      const productName = currentUrl.split("/shop/")[1].split("?")[0];

      if (productName) {
        // Redirect to the new URL
        const newUrl = `/products/${productName}`;
        window.location.href = newUrl;
      }
    }
  }

  function redirectOldWebsiteBlog() {
    if (
      window.location.href.includes(
        `refresh-atheme-vertical-thumbnails-with-arrow-navigation-on-product-pages-no-apps`
      )
    ) {
      /* TODO - redirect to dawn slider pro */
    }
  }

  function isBlogPage() {
    return /blogs\/shopify-tutorials/.test(window.location.href);
  }

  function wrapGistsWithDiv() {
    const $text = document.querySelector(`.article-template__content`);

    const text = $text.innerHTML;


    if (!text.includes(`[gist]`)) {
      return;
    }

    const result = text.replace(/\[gist\](.*?)\[\/gist\]/g, (match, id) => {
      return `<div data-gist-id="${id}"></div>`;
    });

    $text.innerHTML = result;
  }

  function renderGistsDynamically() {
    var $gists = window.document.querySelectorAll(`[data-gist-id]`);


    for (var [i, each] of $gists.entries()) {
      const gistId = each.getAttribute("data-gist-id");

      // Create an iframe, append it to this document where specified
      var gistFrame = window.document.createElement("iframe");
      gistFrame.setAttribute("width", "100%");
      gistFrame.classList = `gistFrame gistFrame--${i}`;
      gistFrame.setAttribute("scrolling", "yes");
      gistFrame.setAttribute("width", "100%");

      var $zone = each;
      $zone.innerHTML = "";
      $zone.appendChild(gistFrame);

      // Create the iframe's document
      var gistFrameHTML =
        "<html><body><scr" +
        `ipt type="text/javascript" src="https://gist.github.com/dpw1/` +
        gistId +
        '.js"></sc' +
        "ript></body></html>";

      // Set iframe's document with a trigger for this document to adjust the height
      var gistFrameDoc = gistFrame.document;

      if (gistFrame.contentDocument) {
        gistFrameDoc = gistFrame.contentDocument;
      } else if (gistFrame.contentWindow) {
        gistFrameDoc = gistFrame.contentWindow.document;
      }

      gistFrameDoc.open();
      gistFrameDoc.writeln(gistFrameHTML);
      gistFrameDoc.close();

      /* Add height to iframe */
      const $iframe = document.querySelector(`.gistFrame--${i}`);

      $iframe.addEventListener("load", async function (e) {
        try {
          var height = $iframe.contentWindow.document.body.scrollHeight;
          $iframe.style.height = `${height}px`;

          /* ======== */
          var $html = gistFrameDoc;

          if (!$html) {
            console.log("lll no $html");
          }

          await sleep(1000);

          console.log("lll html", $html);

          var $meta = $html.querySelector(`.gist-meta a`);

          if (!$meta) {
            console.log("lll no $eta");
          }

          var code = $meta.getAttribute("href");

          const gist = await getPublicGist(gistId);
          const copy = gist.files[Object.keys(gist.files)[0]].content;
          const $el = $iframe.closest(`[data-gist-id]`);

          try {
            $el.insertAdjacentHTML(
              `afterbegin`,
              `<a id="GistButton-${gistId}"  href="#" class="GistRawCode btn" >Copy code</a>`
            );
          } catch (err) {
            $zone.insertAdjacentHTML(
              `afterbegin`,
              `<a id="GistButton-${gistId}"  href="#" class="GistRawCode btn" >Copy code</a>`
            );
          }

          await sleep(50);

          const $button = document.querySelector(`[id='GistButton-${gistId}']`);

          $button.addEventListener("click", async (e) => {
            e.preventDefault();
            const $this = e.target;

            const text = $this.textContent.trim();

            $this.textContent = "Copied!";

            copyToClipboard(copy);

            await sleep(2000);

            $this.textContent = text;
          });
        } catch (err) {
          console.log("lll iframe error: ", err);
        }
      });
    }
  }

  function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
      // IE specific code path to prevent textarea being shown while dialog is visible.
      return clipboardData.setData("Text", text);
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported("copy")
    ) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  function getPublicGist(gistId) {
    return new Promise((resolve, reject) => {
      const url = `https://api.github.com/gists/${gistId}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          resolve(data); // Resolve the promise with the Gist data
        })
        .catch((error) => {
          // Reject the promise with the error
          console.error("Error:", error);
          reject(error);
        });
    });
  }

  function injectNoticeBox() {
    const html = `<div class="NoticeBox NoticeBox--info"><p>This tutorial is compatible only with Shopify's official free themes: <b>Dawn, Refresh, Colorblock, Taste, Ride, Studio, Crave, Origin, Spotlight, Publisher, Sense &amp; Craft.</b></p></div>`;

    const $text = document.querySelector(`.article-template__content`);
    $text.innerHTML = $text.innerHTML.replaceAll(`[noticebox]`, html);
  }

  async function addDiscountCoupon(products=null) {

    let discount;
    if (products === null){
      throw new Error(`No cart. (addDiscountCoupon)`)
    }

    await _waitForElement(`.ec-cart-summary:not([class*='wait'])`);

    const $discount = await _waitForElement(
      `[class*='cart-coupon'] > a`,
      100,
      25
    );

    if (products.length === 2){
      discount = window.discounts[0].coupon;
    } else if (products.length >= 3){
      discount = window.discounts[1].coupon;
    }
    
    if (!$discount) return;

    const $cancel = document.querySelector(`.ec-cart-coupon__button--cancel`);
    if ($cancel) $cancel.click();

    const $forms = document.querySelectorAll(`[class*='ec-cart__discount']`);
    for (const each of $forms) {
      const $redeem = each.querySelector(`[class*='cart-coupon'] > a`);
      if (!$redeem) continue;

      $redeem.click();
      await sleep(50);

      const $input = each.querySelector(`input.form-control__text`);
      if (!$input) continue;

      await sleep(25);

      $input.value = discount;
      $input.dispatchEvent(
        new Event("input", { bubbles: true, cancelable: true })
      );

      await sleep(500);

      const $button = each.querySelector(
        `.ec-cart-coupon__button--apply button`
      );
      if ($button) $button.click();
    }

    if (document.querySelector(`[class*='--discount-coupon']`)) {
      window.discountCodeApplied = true;
    }
  }

 function playThumbnailVideo() {
  const $elements = document.querySelectorAll(".card--has-video");

  if (!$elements) return;

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5, // Trigger when 50% of the element is in view
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const $parent = entry.target;

      if (!entry.isIntersecting) return stopVideo($parent);

      let video = $parent.querySelector(".video");
      const $link = $parent.querySelector("a");
      const $container = $parent.querySelector(".media");
      const $img = $container?.querySelector("img");
      const videoURL = $parent.getAttribute("data-video-demo");


      if (!$container || !$img || !videoURL) return;


      if (!video) {
        const videoHTML = `
          <video class="video" muted loop autoplay>
            <source src="${videoURL}" type="video/mp4">
          </video>
        `;

        console.log('playing video!')
        $container.insertAdjacentHTML("beforeend", videoHTML);
        video = $container.querySelector(".video");
       
      }

      $img.style.opacity = "0";
    });
  }, options);

  $elements.forEach(($parent) => observer.observe($parent));

  function stopVideo($parent) {
    const video = $parent.querySelector(".video");
    const $img = $parent.querySelector(".media img");
    if (video) {
      video.pause();
      video.remove();
    }
    if ($img) $img.style.opacity = "1";
  }
}

  
  function _loadScript(src) {
    return new Promise(function(resolve, reject) {
      var s;
      s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }


async function loadTippy() {
    return new Promise(async (resolve) => {

      if (window.hasOwnProperty(`tippy`)){
        resolve();
        return;
      }

      console.log(`Attempting to load tippy...`)

      await _loadScript(`https://cdnjs.cloudflare.com/ajax/libs/popper.js/2.9.2/umd/popper.min.js`)
      await _loadScript(`https://cdnjs.cloudflare.com/ajax/libs/tippy.js/6.3.7/tippy-bundle.umd.min.js`)

            console.log(`Tippy loaded!`)
      
      resolve();
    });
}

function productPageDropdown() {
  const dropdownTitles = document.querySelectorAll('.dropdown-title');

  dropdownTitles.forEach(title => {
    title.addEventListener('click', (e) => {
      e.preventDefault();
      title.classList.toggle('dropdown-title--active');
    });
  });
}

  function handleHeaderClick(){

    const scroll = [
      {
        'handle': 'about',
        'scrollTo': ''
      }
    ]
    const $items = document.querySelectorAll(`.header__menu-item[data-handle]`);

    if (!$items){
      return
    }

    for (var each of $items){
      each.addEventListener(`click`, function(e){

        const hanlde = e.getAttribute
      })
    }
  }

function scrollTo(selector, offset = 0) {
  const element = document.querySelector(selector);
  if (element) {
    const top = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
}

  function cleanTabsInProductPageDescription(){
     const $links = document.querySelectorAll('.product__description p > a[class*="dropdown"]');
    
    $links.forEach(link => {
        const parentP = link.parentElement;
        if (parentP && parentP.tagName === 'P') {
            parentP.replaceWith(link); // Replace <p> with <a>
        }
    });
  }

  function initTooltips(){

    if (!window.hasOwnProperty("tippy")){
      console.error(`Tippy is not loaded.`);
      return
    }
    
    tippy('[data-tippy-content]', { placement: 'top' });
  }


function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text); 

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}	



  
function makeCopyable() {
    document.querySelectorAll('.copyable:not(.copyable--checked)').forEach((element, index) => {
        // Mark element as processed
        element.classList.add('copyable--checked');

        element.setAttribute(`data-tippy-content`, `Click to copy`)


        // Select the newly injected span
        const span = element

        // Initialize Tippy.js
        const tooltip = tippy(span, {
            content: span.getAttribute('data-tippy-content'),
        
            placement: 'top',
        });

        // Add event listener for copying
        span.addEventListener('click', function () {
            const textToCopy = this.textContent.trim();
            copyToClipboard(textToCopy);

            // Change tooltip content to "Copied!" and show it
            tooltip.setContent('Copied!');
            tooltip.show();

            span.addEventListener('mouseleave', () => {
             

tooltip.hide()
              setTimeout(() => {
                   tooltip.setContent(span.getAttribute('data-tippy-content'));
              }, 250)
            });
  
              
   
        });
    });
}

  function addToCart(variantID) {
  return new Promise((resolve, reject) => {
    const items = [{ quantity: 1, id: parseInt(variantID) }];

    fetch('/cart/add.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then(response => {
        if (!response.ok) {
          // Parse error response from Shopify (if available)
          return response.json().then(errorData => {
            throw new Error(errorData?.description || `Request failed with status ${response.status}`);
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        resolve(data); // Resolve the promise with the response data
      })
      .catch(error => {
        console.error('Error occurred:', error.message);
        reject(error); // Reject the promise with the error
      });
  });
}

function isVariantInCart(variantID) {
  return new Promise((resolve, reject) => {
    // Fetch the current cart data from Shopify
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          // Handle errors from the fetch request
          return response.json().then(errorData => {
            throw new Error(errorData?.description || `Request failed with status ${response.status}`);
          });
        }
        return response.json();
      })
      .then(cartData => {
        // Check if the cart contains the specific variant ID
        const isInCart = cartData.items.some(item => item.variant_id === parseInt(variantID));
        resolve(isInCart); // Resolve the promise with true/false
      })
      .catch(error => {
        console.error('Error occurred while checking cart:', error.message);
        reject(error); // Reject the promise with the error
      });
  });
}
  
function handleQuickDownloadButton(){
  const $btn = document.querySelector(`.download-now-btn`);

  if (!$btn){
    return
  }

  $btn.addEventListener(`click`, async function(e){
    e.preventDefault();
    const variantID = e.target.getAttribute(`data-variant-id`).trim();

    if (!variantID || variantID === ""){
      return
    }

    const text = e.target.textContent;

    e.target.textContent = `Loading...`

    const isInCart = await isVariantInCart(variantID);

    if (!isInCart){
    await addToCart(variantID);
      
    }

    await addShopifyProductsToEcwidCart();

    e.target.textContent = text
  })
}
  

// Call the function to activate the behavior


  return {
    test:test,
    scrollTo:scrollTo,
    wrapGistsWithDiv:wrapGistsWithDiv,
    loadTippy: loadTippy,
    handleQuickDownloadButton:handleQuickDownloadButton,
    init: function () {
      redirectOldWebsiteShop();
      redirectOldWebsiteBlog();
      handleBackButton();
      redirectToCartIfEcwidCartIsOpen();
      if (isBlogPage()) {
        injectNoticeBox();
        
      }

      if (_isProductPage()){
        cleanTabsInProductPageDescription();
        handleQuickDownloadButton();
      }
      document.addEventListener("DOMContentLoaded", function () {
        openEcwidCheckoutOnShopifyCheckoutClick();
        oneQuantityPerProduct();
     
        if (isBlogPage()) {
          wrapGistsWithDiv();
          renderGistsDynamically();
        }

        if (_isProductPage()){
          productPageDropdown();
        }

 
      });

      window.addEventListener("resize", function () {});

      window.addEventListener("load", function () {
          
        playThumbnailVideo();
        console.log(`Page loaded`)
        loadTippy().then(_ => {
        

              if (isBlogPage()) {
        makeCopyable();
        
      }

              initTooltips();
        })



      });

      window.addEventListener("scroll", function () {});
    },
  };
})();

ezfy.init();
